import styled from "styled-components";

export const Container = styled.div`
  margin-top: 20px;

  h1 {
    margin-bottom: 20px;
  }
`;
